<template>
  <div class="lm-dropdown">
    <div
      :id="`dd-btn-${dropdownId}`"
      class="dropdown-btn"
      :class="{ 'disabled': disabled }"
      @click="openDropdown"
    >
      <b-popover
        v-if="!disabled"
        :target="`dd-btn-${dropdownId}`"
        :placement="tooltipPosition"
        triggers="hover"
        :content="tooltip"
      ></b-popover>
      <slot></slot>
    </div>
    <div
      :data-close-after-pick="closeAfterPick"
      class="dropdown-content mt-1"
      :id="`dd-content-${dropdownId}`"
    >
      <slot name="content">
        <!-- user list  template -->
        <div v-if="template === 'user-list'" class="dropdown-content-template">
          <input v-model="textSearch" class="dropdown-searcher" type="text" placeholder="Buscar">
          <span
            v-for="(item, index) of itemsComputed"
            :key="index"
            @click="$emit('input', item)"
            :class="{ 'selected': value && value.id === item.id }"
          >
            {{ item.name }}
          </span>
        </div>
      </slot>
    </div>
  </div>
</template>

<script>
import commonsApi from '@/api/commons'

export default {
  props: {
    id: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    tooltip: {
      type: String,
      default: null
    },
    tooltipPosition: {
      type: String,
      default: 'top'
    },
    closeAfterPick: {
      type: Boolean,
      default: false
    },
    template: {
      type: String,
      default: null
    },
    value: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      textSearch: '',
      items: []
    }
  },
  computed: {
    itemsComputed () {
      if (this.textSearch) {
        const search = new RegExp(this.textSearch, 'i')
        return this.items.filter(el => el.name.search(search) !== -1)
      }
      return this.items
    },
    dropdownId () {
      return this.id || this._uid
    }
  },
  methods: {
    openDropdown () {
      if (!this.disabled) {
        document.getElementById(`dd-content-${this.dropdownId}`).classList.toggle('show')
      }
    }
  },
  async created () {
    window.onclick = function (event) {
      const target = event.target
      const content = target.closest('.dropdown-content')
      const button = target.closest('.dropdown-btn')
      if (
        (content === null || content.dataset.closeAfterPick) &&
        button === null
      ) {
        let dropdowns = document.getElementsByClassName('dropdown-content')
        for (const node of dropdowns) {
          if (node.classList.contains('show')) {
            node.classList.remove('show')
          }
        }
      }
    }

    if (this.template === 'user-list') {
      const response = await commonsApi.axiosGetWrapper('/users/all')
      this.items = response.data.items
    }
  }
}
</script>

<style lang="sass" scoped>
.lm-dropdown
  position: relative
  display: inline-block
  .dropdown-searcher
    padding: .5rem 1rem
    outline: none
    border: none
    border-bottom: 1px solid #ededed
    &::placeholder
      font-size: .8rem
      color: #a8a8a8
  .dropdown-btn
    cursor: pointer
    &.disabled
      cursor: inherit
  .dropdown-content
    right: 0
    border: 1px solid #ededed
    visibility: hidden
    position: absolute
    background: white
    min-width: 200px
    max-height: 350px
    overflow: auto
    box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2)
    z-index: 10
    &::-webkit-scrollbar
      height: 4px
      width: 4px
    &::-webkit-scrollbar-thumb
      border-radius: 20px
      background: #cccccc
    &::-webkit-scrollbar-thumb:hover
      background: #a8a8a8
    &.show
      visibility: visible

    .dropdown-content-template
      display: flex
      flex-direction: column
      & > span
        cursor: pointer
        padding: .5rem 1rem
        &.selected, &:hover
          background: #ededed
</style>
